import { Drawer, VStack, Box, HStack, Text, Badge, Portal, CloseButton } from '@chakra-ui/react';
import type { ItineraryTurfPoolDto } from '../../../types/campaign'
import { getTurfColor } from '../../../lib/mapConfig'
import { doorsAndPeople } from '../../../lib/turfCounts'
import { FollowUpKindBadge } from '../followUp/FollowUpKindBadge'

interface AssignTurfSheetProps {
  isOpen: boolean
  onClose: () => void
  turfs: ItineraryTurfPoolDto[]
  onSelect: (turf: ItineraryTurfPoolDto) => void
}

export function AssignTurfSheet({ isOpen, onClose, turfs, onSelect }: AssignTurfSheetProps) {
  return (
    <Drawer.Root open={isOpen} placement='bottom' onOpenChange={e => {
      if (!e.open) {
        onClose();
      }
    }}>
      <Portal>

        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content borderTopRadius="xl" maxH="80vh" pb="env(safe-area-inset-bottom, 0px)">
            <Drawer.CloseTrigger asChild><CloseButton size="sm" /></Drawer.CloseTrigger>
            <Drawer.Header borderBottomWidth="1px">Assign a turf</Drawer.Header>
            <Drawer.Body>
              <VStack gap={2} align="stretch" py={2}>
                {turfs.length === 0 && <Text color="gray.400" fontSize="sm">No turfs available</Text>}
                {turfs.map(turf => (
                  <Box
                    textAlign="left"
                    borderWidth="1px"
                    borderColor="gray.200"
                    borderLeftWidth="4px"
                    borderLeftColor={getTurfColor(turf.turfIndex)}
                    borderRadius="md"
                    p={3}
                    minH="56px"
                    _active={{ bg: 'gray.50' }}
                    asChild><button key={turf.turfId} onClick={() => { onSelect(turf); onClose() }}>
                      <Text fontWeight="semibold" fontSize="sm" lineClamp={1}>{turf.turfLabel}</Text>
                      <Text color="gray.500" fontSize="xs" lineClamp={1}>{turf.turfMapLabel}</Text>
                      <HStack gap={1} mt={1} flexWrap="wrap">
                        <Badge variant="outline" fontSize="2xs">{doorsAndPeople(turf.doorCount, turf.memberCount)}</Badge>
                        {turf.purpose === 'FollowUp' && turf.followUpKind && (
                          <FollowUpKindBadge kind={turf.followUpKind} customName={turf.followUpCustomKindName} />
                        )}
                        {turf.needsFollowUp && <Badge colorPalette="orange" fontSize="2xs">revisit</Badge>}
                      </HStack>
                    </button></Box>
                ))}
              </VStack>
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>

      </Portal>
    </Drawer.Root>
  );
}
